import { Component, OnInit } from '@angular/core';
import { NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CustomPaggerService } from 'projects/Autofacets-Core/src/app/common-services/custom-pagger.service';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { BaseService } from 'projects/Autofacets-Core/src/app/services/base.service';
import * as Enums from 'projects/Autofacets-Core/src/app/utils/enums';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { UserDealersModel } from '../../../business-entities/dealer-details.model';
import { DealerParkingImage, DealerParkingImageModel } from '../../../business-entities/dealer-parking-model';
import { DealerViewModel } from '../../../business-entities/dealer-view-model';
import { SelectListItemViewModel } from '../../../business-entities/select-list-item-view-model';
import { UserRoleMenu } from '../../../business-entities/user-role-menu.model';
import { DealerSearchService } from '../../../business-services/dealer-serach.service';
import { DealerBusinessService } from '../../../business-services/dealer.service';
import { ImageService } from '../../../services/image.service';
import { DealerParkingBusinessService } from './../../../business-services/dealer-parking.service';
@Component({
  selector: 'app-dealer-parking',
  templateUrl: './dealer-parking.component.html'
})
export class DealerParkingComponent implements OnInit {
  imageBaseData: string | ArrayBuffer = null;
  dealerSelected: string
  dealerList: Array<SelectListItemViewModel>;
  selectedDealerId: string
  isView: boolean = true;
  dealerParkingDetails: DealerParkingImage;
  dealerValues: DealerViewModel[];
  dealerParkingImage: DealerParkingImageModel = {
    Createdby: '',
    DealerId: '',
    Image: '',
    ImageBinaryData: '',
    MimeType: '',
  };
  isData: boolean;
  parkingImageName: string
  image: string | ArrayBuffer;
  userRoleRightsDetails: UserRoleMenu;
  constructor(
    public pService: CustomPaggerService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private secureStorage: SecureStorage,
    public dealerBusinessService: DealerBusinessService,
    private translate: TranslateService,
    public dealerParkingService: DealerParkingBusinessService,
    private userService: UserDataService,
    private imageService:ImageService

  ) { }

  ngOnInit(): void {
    this.dealerSelected = this.userService.currentUserValue.defaultDealerId;
    this.selectedDealerId = this.userService.currentUserValue.defaultDealerId;
    this.userRoleRightsDetails = (this.userService.currentUserValue.userRoleMenuDetails as any[]).find(menu => menu.moduleId === Enums.ModuleNames.UploadParkingImage);
    this.getUserDealers();
  }

  onDealerSelected(dealerId: string) {
    this.selectedDealerId= dealerId ?? undefined ;
    if(this.selectedDealerId===undefined)
    {
      this.isView=true;
      this.isData=false;
    }
    this.getDealerParkingImage(this.selectedDealerId);
  }

  ngOnDestroy(): void {
    this.secureStorage.removeKey('dealerID');
  }
  async getUserDealers(){
    await this.dealerBusinessService.getUserDealersDropdown().then((response) => {
      this.dealerList = this.mapdealer(response.userDealersModel);
      if(this.dealerList && this.dealerList.length == 1){
          this.selectedDealerId = this.dealerList[0].value;
          this.dealerSelected = this.dealerList[0].value;
          this.isView = false;
      }
      else{ this.isView = true}
    this.getDealerParkingImage(this.selectedDealerId);

    })
  }
  mapdealer(array: UserDealersModel[]){
    let supperArray = [];
    if (array && array.length > 0) {
      array.forEach(element=>{
        let single = Object();
        single.value = element.dealerId
        single.text = element.dealerName

        supperArray.push(single);
      })
    }
    return supperArray;
  }
  onChangeFileUpload(files: FileList) {
    const me = this;
    const file = files[0];
    this.dealerParkingImage.MimeType = files[0].type;
    this.dealerParkingImage.Image = files[0].name;
    this.parkingImageName = file.name;
    const reader = new FileReader();
    const max_size = 1048576 ;
    const max_height = 491;
    const max_width = 930;
    let imgerrormsg = this.translate.instant("lblImageFormatError");
    reader.readAsDataURL(file);
    const isValidFormat=this.imageService.validateImageFormat(this.dealerParkingImage.MimeType);
    if(isValidFormat)
    {
      reader.onload = (readerEvent:any) => {
        const img = new Image();
        img.src = readerEvent.target.result;
        img.onload = _rs => {
          const img_height = img.naturalHeight;
          const img_width = img.naturalWidth;
          if (img_height !== max_height || img_width !== max_width || file.size > max_size) {
              let errorMsg = this.translate.instant("lblParkingImageValidation")
              this.toastr.error(errorMsg);
              return false;
          } else {
            if (this.dealerParkingDetails?.imagePath) {
              this.dealerParkingDetails.imagePath = "";
            }
            me.imageBaseData = reader.result;
            this.dealerParkingImage.ImageBinaryData = reader.result.toString().replace('data:' + this.dealerParkingImage.MimeType + ';base64,', '');
            this.image = me.imageBaseData;
          }
      };

      };
    }
    else {
      this.toastr.error(imgerrormsg);
    }
    reader.onerror = function (_error) {
      // This is intentional
    };

  }

  formatter = (result: SelectListItemViewModel) => result.text.toUpperCase();

  search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => {
        return term === '' ? []
          : this.dealerList.filter(v => v.text.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10)
      })
    )

  setDealer(event: NgbTypeaheadSelectItemEvent) {
    this.isView = false;
    event.preventDefault();
    this.selectedDealerId = event.item.value;
    this.dealerSelected = event.item.text;
    this.getDealerParkingImage(this.selectedDealerId);
  }

  handleResultSelected(result) {
    this.search = result;
  }
  getDealerParkingImage(dealerId: string) {
    if (dealerId !== undefined) {
      const Id = dealerId
      this.image = null
      this.dealerParkingDetails = null
      this.spinner.show();
      this.dealerParkingService.getDealerParkingImage(Id).then((response) => {
        this.isData = true;
        if (response.dealerParkingImage) {
          this.dealerParkingDetails = response.dealerParkingImage;
          this.image = response.dealerParkingImage.imagePath;
        }
        if (this.dealerParkingDetails) {
          let dealerId = this.dealerParkingDetails.dealerId;
          if(this.dealerList === null || this.dealerList === undefined){
            this.dealerSelected = this.dealerParkingDetails.dealerName
          }
          else{
            this.dealerSelected = this.dealerList.filter(x => (x.value === dealerId) ? x.text : '')[0].text;
          }
        }
        else {
          let dealerId = Id;
          if(this.dealerList === null || this.dealerList === undefined){
            this.dealerSelected = this.dealerParkingDetails.dealerName
          }
          else{
            this.dealerSelected = this.dealerList.filter(x => (x.value === dealerId) ? x.text : '')[0].text;
          }
        }
      })
    }
    this.spinner.hide();
  }
  handleImageError(message){
    this.spinner.hide();
    this.toastr.error(message);
  }
  onSubmit() {
    this.spinner.show();
    let sucessmsg = this.translate.instant("lblToasterDealerParkingImgSuccess");
    let errormsg = this.translate.instant("lblToasterParkingSomethingWentWrongError");
    let imgerrormsg = this.translate.instant("lblImageFormatError");
    this.dealerParkingImage.DealerId = this.selectedDealerId
    this.dealerParkingImage.Createdby = this.userService.currentUserValue.id;
    const isValidFormat=this.imageService.validateImageFormat(this.dealerParkingImage.MimeType);
    if (this.dealerParkingImage != null) {
      if (this.dealerParkingImage.MimeType === '' && this.dealerParkingImage.Image !== '') {
        this.handleImageError(imgerrormsg)
      }
      else if (isValidFormat) {
        this.dealerParkingService.addDealerparkingImage(this.dealerParkingImage).then((_res) => {
          this.toastr.success(sucessmsg);
          this.spinner.hide();
        }, _error => {
          this.toastr.error(errormsg);
          this.spinner.hide();
        });
      }
      else {
        this.handleImageError(imgerrormsg)
      }
    }
  }
}
